import { render, staticRenderFns } from "./InputParser.vue?vue&type=template&id=0c840e50&scoped=true&"
import script from "./InputParser.vue?vue&type=script&lang=js&"
export * from "./InputParser.vue?vue&type=script&lang=js&"
import style0 from "./InputParser.vue?vue&type=style&index=0&id=0c840e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c840e50",
  null
  
)

export default component.exports